var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page page-dashboard",attrs:{"id":"page-dashboard"}},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page-heading has-padding"},[_c('heading-wave',[_vm._v(" "+_vm._s(_vm.$ls.PersonProfile_Practices_Heading)+" ")])],1),_c('practices-table')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }